"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postDataToServiceWithData = exports.postDataToServiceWithRedux = exports.getDataFromServiceWithData = exports.getDataFromServiceWithRedux = exports.deleteDataFromServiceWithRedux = exports.deleteDataFromServiceWithData = void 0;
var StoreHelpers_1 = require("../types/StoreHelpers");
/** for DELETE requests. This variation will return data without going through the store. Error and Loading states
 * will be updated in the store */
function deleteDataFromServiceWithData(storeState, dispatch, deleteCall, statusCodeCallback
// @ts-ignore
) {
    return __awaiter(this, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({
                        type: storeState.LOADING,
                        loading: true,
                        error: null
                    });
                    return [4 /*yield*/, deleteCall()];
                case 1:
                    result = _a.sent();
                    //Check for result, sometimes, result can be null, indicates 5xx error
                    if (result) {
                        return [2 /*return*/, handlePostDeleteActionWithData(storeState, dispatch, result, statusCodeCallback)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    handleStatusCode(error_1.response.status, statusCodeCallback);
                    dispatch({
                        type: storeState.ERROR,
                        loading: false,
                        error: error_1.response.data.message
                    });
                    return [2 /*return*/];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.deleteDataFromServiceWithData = deleteDataFromServiceWithData;
/** for DELETE requests. This variation will dispatch data to the store. Error and Loading states
 * will be updated in the store */
function deleteDataFromServiceWithRedux(storeState, dispatch, deleteCall, statusCodeCallback
// @ts-ignore
) {
    return __awaiter(this, void 0, void 0, function () {
        var result, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({
                        type: storeState.LOADING,
                        loading: true,
                        error: null
                    });
                    return [4 /*yield*/, deleteCall()];
                case 1:
                    result = _a.sent();
                    //Check for result, sometimes, result can be null, indicates 5xx error
                    if (result) {
                        return [2 /*return*/, handlePostDeleteActionWithRedux(storeState, dispatch, result, statusCodeCallback)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    handleStatusCode(error_2.response.status, statusCodeCallback);
                    dispatch({
                        type: storeState.ERROR,
                        loading: false,
                        error: error_2.response.data.message
                    });
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.deleteDataFromServiceWithRedux = deleteDataFromServiceWithRedux;
/** for GET requests. This variation will dispatch data to the store. Error and Loading states
 * will be updated in the store */
function getDataFromServiceWithRedux(storeState, dispatch, fetchCall, statusCodeCallback
// @ts-ignore
) {
    return __awaiter(this, void 0, void 0, function () {
        var result, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({
                        type: storeState.LOADING,
                        loading: true,
                        error: null
                    });
                    return [4 /*yield*/, fetchCall()];
                case 1:
                    result = _a.sent();
                    //Check for result, sometimes, result can be null, indicates 5xx error
                    if (result) {
                        return [2 /*return*/, handleGetActionWithRedux(storeState, dispatch, result, statusCodeCallback)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    handleStatusCode(error_3.response.status, statusCodeCallback);
                    dispatch({
                        type: storeState.ERROR,
                        loading: false,
                        error: error_3.response.data.message
                    });
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.getDataFromServiceWithRedux = getDataFromServiceWithRedux;
function handleGetActionWithRedux(storeState, dispatch, response, statusCodeCallback) {
    return __awaiter(this, void 0, void 0, function () {
        var hasHit4xxRoutes;
        return __generator(this, function (_a) {
            try {
                hasHit4xxRoutes = check4xxRoutes(storeState, dispatch, response, statusCodeCallback);
                if (!hasHit4xxRoutes)
                    return [2 /*return*/, false];
                if (response.status === 200) {
                    dispatch({
                        type: storeState.SUCCESS,
                        loading: false,
                        error: null,
                        data: response.data
                    });
                    return [2 /*return*/, true];
                }
                return [2 /*return*/, false];
            }
            catch (error) {
                handleStatusCode(error.response.status, statusCodeCallback);
                dispatch({
                    type: storeState.ERROR,
                    loading: false,
                    error: error.response.data.message
                });
                return [2 /*return*/, false];
            }
            return [2 /*return*/];
        });
    });
}
/** for GET requests. This variation will return data without dispatching it to the store. Error and Loading states
 * will be updated in the store */
function getDataFromServiceWithData(storeState, dispatch, fetchCall, statusCodeCallback
// @ts-ignore
) {
    return __awaiter(this, void 0, void 0, function () {
        var result, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({
                        type: storeState.LOADING,
                        loading: true,
                        error: null
                    });
                    return [4 /*yield*/, fetchCall()];
                case 1:
                    result = _a.sent();
                    //Check for result, sometimes, result can be null, indicates 5xx error
                    if (result) {
                        return [2 /*return*/, handleGetActionWithData(storeState, dispatch, result, statusCodeCallback)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    handleStatusCode(error_4.response.status, statusCodeCallback);
                    dispatch({
                        type: storeState.ERROR,
                        loading: false,
                        error: error_4.response.data.message
                    });
                    return [2 /*return*/];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.getDataFromServiceWithData = getDataFromServiceWithData;
function handleGetActionWithData(storeState, dispatch, response, statusCodeCallback) {
    return __awaiter(this, void 0, void 0, function () {
        var hasHit4xxRoutes;
        return __generator(this, function (_a) {
            try {
                hasHit4xxRoutes = check4xxRoutes(storeState, dispatch, response, statusCodeCallback);
                if (!hasHit4xxRoutes)
                    return [2 /*return*/];
                if (response.status === 200) {
                    return [2 /*return*/, response.data];
                }
                return [2 /*return*/];
            }
            catch (error) {
                handleStatusCode(error.response.status, statusCodeCallback);
                dispatch({
                    type: storeState.ERROR,
                    loading: false,
                    error: error.response.data.message
                });
                return [2 /*return*/];
            }
            return [2 /*return*/];
        });
    });
}
/** for POST requests. This variation will dispatch data to the store. Error and Loading states
 * will be updated in the store */
function postDataToServiceWithRedux(storeState, dispatch, postCall, statusCodeCallback
// @ts-ignore
) {
    return __awaiter(this, void 0, void 0, function () {
        var result, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({
                        type: storeState.LOADING,
                        loading: true,
                        error: null
                    });
                    return [4 /*yield*/, postCall()];
                case 1:
                    result = _a.sent();
                    //Check for result, sometimes, result can be null, indicates 5xx error
                    if (result) {
                        return [2 /*return*/, handlePostDeleteActionWithRedux(storeState, dispatch, result, statusCodeCallback)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_5 = _a.sent();
                    handleStatusCode(error_5.response.status, statusCodeCallback);
                    dispatch({
                        type: storeState.ERROR,
                        loading: false,
                        error: error_5.response.data.message
                    });
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.postDataToServiceWithRedux = postDataToServiceWithRedux;
function handlePostDeleteActionWithRedux(storeState, dispatch, response, statusCodeCallback) {
    return __awaiter(this, void 0, void 0, function () {
        var hasHit4xxRoutes;
        return __generator(this, function (_a) {
            try {
                hasHit4xxRoutes = check4xxRoutes(storeState, dispatch, response, statusCodeCallback);
                if (!hasHit4xxRoutes)
                    return [2 /*return*/, false];
                if (response.status === 200 || response.status === 204) {
                    dispatch({
                        type: storeState.SUCCESS,
                        loading: false,
                        error: null,
                        data: response.data
                    });
                    return [2 /*return*/, true];
                }
                return [2 /*return*/, false];
            }
            catch (error) {
                handleStatusCode(error.response.status, statusCodeCallback);
                dispatch({
                    type: storeState.ERROR,
                    loading: false,
                    error: error.response.data.message
                });
                return [2 /*return*/, false];
            }
            return [2 /*return*/];
        });
    });
}
/** for POST requests. This variation will return data without dispatching it to the store. Error and Loading states
 * will be updated in the store */
function postDataToServiceWithData(storeState, dispatch, postCall, statusCodeCallback
// @ts-ignore
) {
    return __awaiter(this, void 0, void 0, function () {
        var result, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({
                        type: storeState.LOADING,
                        loading: true,
                        error: null
                    });
                    return [4 /*yield*/, postCall()];
                case 1:
                    result = _a.sent();
                    //Check for result, sometimes, result can be null, indicates 5xx error
                    if (result) {
                        return [2 /*return*/, handlePostDeleteActionWithData(storeState, dispatch, result, statusCodeCallback)];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_6 = _a.sent();
                    handleStatusCode(error_6.response.status, statusCodeCallback);
                    dispatch({
                        type: storeState.ERROR,
                        loading: false,
                        error: error_6.response.data.message
                    });
                    return [2 /*return*/];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.postDataToServiceWithData = postDataToServiceWithData;
function handlePostDeleteActionWithData(storeState, dispatch, response, statusCodeCallback) {
    return __awaiter(this, void 0, void 0, function () {
        var hasHit4xxRoutes;
        return __generator(this, function (_a) {
            try {
                hasHit4xxRoutes = check4xxRoutes(storeState, dispatch, response, statusCodeCallback);
                if (!hasHit4xxRoutes)
                    return [2 /*return*/];
                if (response.status === 200 || response.status === 204) {
                    return [2 /*return*/, response.data];
                }
                return [2 /*return*/];
            }
            catch (error) {
                handleStatusCode(error.response.status, statusCodeCallback);
                dispatch({
                    type: storeState.ERROR,
                    loading: false,
                    error: error.response.data.message
                });
                return [2 /*return*/];
            }
            return [2 /*return*/];
        });
    });
}
function check4xxRoutes(storeState, dispatch, response, statusCodeCallback) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                if (response.status === 400) {
                    dispatch({
                        type: storeState.ERROR,
                        loading: false,
                        error: "Validation Error"
                    });
                    statusCodeCallback(StoreHelpers_1.StatusCode4xx.FourZeroZero);
                    return [2 /*return*/, false];
                }
                if (response.status === 401) {
                    dispatch({
                        type: storeState.ERROR,
                        loading: false,
                        error: "Not Authenticated"
                    });
                    statusCodeCallback(StoreHelpers_1.StatusCode4xx.FourZeroOne);
                    return [2 /*return*/, false];
                }
                if (response.status === 403) {
                    dispatch({
                        type: storeState.ERROR,
                        loading: false,
                        error: "Not Authorized"
                    });
                    statusCodeCallback(StoreHelpers_1.StatusCode4xx.FourZeroThree);
                    return [2 /*return*/, false];
                }
                if (response.status === 404) {
                    dispatch({
                        type: storeState.ERROR,
                        loading: false,
                        error: "Resource not found"
                    });
                    statusCodeCallback(StoreHelpers_1.StatusCode4xx.FourZeroFour);
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, true];
            }
            catch (error) {
                handleStatusCode(error.response.status, statusCodeCallback);
                dispatch({
                    type: storeState.ERROR,
                    loading: false,
                    error: error.response.data.message
                });
                return [2 /*return*/, false];
            }
            return [2 /*return*/];
        });
    });
}
function handleStatusCode(code, statusCodeAction) {
    if (!code)
        return;
    switch (code) {
        case 401:
            statusCodeAction(StoreHelpers_1.StatusCode4xx.FourZeroOne);
            return;
        case 403:
            statusCodeAction(StoreHelpers_1.StatusCode4xx.FourZeroThree);
            return;
        case 404:
            statusCodeAction(StoreHelpers_1.StatusCode4xx.FourZeroFour);
            return;
    }
}
